function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tick1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 2 101 L 261 101 L 261 302.378906 L 2 302.378906 Z M 2 101 "
})));

function SvgTickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    viewBox: "0 0 262.5 337.500003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "tickicon"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tick1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,70.588684%,62.348938%)",
      fillOpacity: 1
    },
    d: "M 254.234375 108.152344 C 245.980469 99.882812 232.597656 99.882812 224.339844 108.152344 L 90.253906 242.488281 L 38.160156 190.292969 C 29.902344 182.023438 16.519531 182.023438 8.265625 190.292969 C 0.0117188 198.5625 0.0117188 211.972656 8.265625 220.242188 L 75.308594 287.410156 L 90.253906 302.382812 L 105.203125 287.410156 L 254.234375 138.101562 C 262.488281 129.832031 262.488281 116.421875 254.234375 108.152344 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/TickIcon.c52ae245.svg";
export { ForwardRef as ReactComponent };